import * as React from "react";
import type { SVGProps } from "react";
const SvgExternalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    viewBox="-5 -10 125 125.002"
    {...props}
  >
    <path
      d="M113.124-3.124Q106.249-10 96.564-10H18.438Q8.754-10 1.876-3.124-5 3.754-5 13.438v78.125q0 9.684 6.876 16.562 6.878 6.877 16.562 6.877h78.125q9.685 0 16.56-6.877Q120 101.247 120 91.563V13.438q0-9.685-6.876-16.562M99.168 55.105q-.002 3.417-3.174 4.801-1.059.406-2.035.407-2.196-.001-3.662-1.547L78.58 47.048 35.123 90.506q-1.547 1.546-3.663 1.546-2.117 0-3.663-1.546l-8.3-8.302q-1.547-1.546-1.547-3.662 0-2.114 1.546-3.662l43.458-43.458-11.718-11.719q-2.524-2.358-1.14-5.696 1.383-3.174 4.801-3.174H93.96q2.115 0 3.663 1.547 1.546 1.545 1.546 3.662Z"
      style={{
        strokeWidth: 0.998873,
      }}
    />
  </svg>
);
export default SvgExternalIcon;
